export default {
  size_tu: "size_tu",
  size_fr: "size_fr",
  size_int: "size_int",
  size_double: "size_double",
  size_multiple: "size_multiple",
  size_us: "size_us",
  size_pants: "size_pants",
  size_num: "size_num",
};
